import "../css/eventPinSelector.css";
import { useLanguage } from "../components/Language.js";

function EventPinSelector({handleEventSave}) {

  const {language} = useLanguage();

  const translations = {
    en: {
      clickPlacePin: "Click on the map to place your pin",
      done: "Done",
           
    },

    gd: {
      clickPlacePin: "Cliog air a' mhapa gus do phrìne a shuidheachadh",
      done: "Dèante",
    },
};


    return (

        <div className="event-pin-container">
            <p>{translations[language].clickPlacePin}</p>
            <button id="pin-confirm-button" onClick={()=> handleEventSave()}>{translations[language].done}</button>
        </div>
      );
    }
    
    export default EventPinSelector;